/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

interface BuildAuthRedirectUrlOptions {
	authPath: string;
	redirectUrl: string;
}

export const buildAuthRedirectUrl = ({ authPath, redirectUrl }: BuildAuthRedirectUrlOptions): string =>
	`${authPath}?redirectUrl=${encodeURIComponent(redirectUrl)}`;
